export default "__VITE_ASSET___yh0CpAf__"